export default {
  // API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8000/api',
  API_ENDPOINT: `https://stark-waters-29564.herokuapp.com/api` || 'http://localhost:8000/api',
  TOKEN_KEY: 'watchdog-auth-token',
}